// vip会议室预约
const vipmeetingStart = r => require.ensure([], () => r(require('@/page/vipmeeting/start')), 'vipmeeting');
const vipmeetingIndex = r => require.ensure([], () => r(require('@/page/vipmeeting/index')), 'vipmeeting');
const vipcalendar = r => require.ensure([], () => r(require('@/page/vipmeeting/calendar')), 'vipmeeting');
const vipconfirmOrder = r => require.ensure([], () => r(require('@/page/vipmeeting/confirmOrder')), 'vipmeeting');
const vippayment = r => require.ensure([], () => r(require('@/page/vipmeeting/payment')), 'vipmeeting');
const vippayresult = r => require.ensure([], () => r(require('@/page/vipmeeting/payresult')), 'vipmeeting');
const viporders = r => require.ensure([], () => r(require('@/page/vipmeeting/orders')), 'vipmeeting');
const viporderDetail = r => require.ensure([], () => r(require('@/page/vipmeeting/orderDetail')), 'vipmeeting');

export default [{
	path: '/vipmeeting/start',
	component: vipmeetingStart,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
},{
	path: '/vipmeeting/home',
	component: vipmeetingIndex,
	meta: {
		requireAuth: true,
		code: 'vipmeeting',
	},
},{
	path: '/vipmeeting/confirm',
	component: vipconfirmOrder,
	meta: {
		requireAuth: true,
		code: 'vipmeeting',
	},
},{
	path: '/vipmeeting/payment',
	component: vippayment,
	meta: {
		requireAuth: true,
		code: 'vipmeeting',
	},
},{
	path: '/vipmeeting/payresult',
	component: vippayresult,
	meta: {
		requireAuth: true,
		code: 'vipmeeting',
	},
},{
	path: '/vipmeeting/orders',
	component: viporders,
	meta: {
		requireAuth: true,
		code: 'vipmeeting',
	},
},{
	path: '/vipmeeting/orders/detail',
	component: viporderDetail,
	meta: {
		requireAuth: true,
		code: 'vipmeeting',
	},
},{
	path: '/vipmeeting/calendar',
	component: vipcalendar,
	meta: {
		requireAuth: true,
		code: 'vipmeeting',
	},
}
]